import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild, ViewContainerRef, ɵɵsetNgModuleScope } from '@angular/core';
import { paragraphMapper } from 'src/app/models/paragraphs.model';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})


export class PageLayoutComponent implements OnInit {
  @Input() data: any; // This should have a property called paragraphs which is an array of paragraph data.
  @ViewChild('dynamicParagraph') dynamicParagraph: ViewContainerRef | any;

  loading: boolean = true;
  partials: any[] = [];
  breadcrumbs: any[] = [];

  constructor(dynamicParagraph: ViewContainerRef) {
    this.dynamicParagraph = dynamicParagraph;
  }
  async ngOnInit() {
    this.partials = Array.isArray(this.data[this.data.type + '_partials']) ? this.data[this.data.type + '_partials'] : [];
    const viewContainerRef = this.dynamicParagraph; // Move this line outside the loop
    viewContainerRef.clear(); // Clear the view container once

    for (const paragraph of this.partials) {
      const paragraphType = paragraph.type;
      const paragraphData = paragraph;

      const module: any = await paragraphMapper(paragraphType);

      if (module && module.component) {
        ɵɵsetNgModuleScope(module, {
          declarations: [module.component],
          imports: [CommonModule],
          exports: [module.component]
        });

        const componentRef: any = viewContainerRef.createComponent(module.component);

        if (paragraphData) {
          componentRef.instance.data = paragraphData;
        }

        this.loading = false;
      } else {
        console.error(`Paragraph type ${paragraphType} not found`);
      }
    }
  }

}